// extracted by mini-css-extract-plugin
export default {"foundation":"Schools_foundation__t5UCQ"};